/**
 * Playmaker — OAuth callback bridge.
 *
 * Microsoft redirects the browser to /auth/outlook/callback with ?code + ?state
 * (this path is registered in Azure). Because /auth/* is a frontend route,
 * we forward the same query string to the backend endpoint
 * /api/comms/outlook/callback, which exchanges the code, persists the
 * encrypted refresh_token, and redirects to /settings/integrations.
 */
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function OAuthCallback({ provider }) {
  const [params] = useSearchParams();

  useEffect(() => {
    const code = params.get("code");
    const state = params.get("state");
    const error = params.get("error");
    const backendBase = process.env.REACT_APP_BACKEND_URL || "";
    if (error || !code || !state) {
      window.location.replace(`/settings/integrations?oauth_error=${encodeURIComponent(error || "missing_code")}`);
      return;
    }
    const qs = new URLSearchParams({ code, state }).toString();
    window.location.replace(`${backendBase}/api/comms/${provider}/callback?${qs}`);
  }, [params, provider]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid={`oauth-callback-${provider}`}>
      <div className="text-center">
        <div className="font-display text-lg font-bold tracking-tight text-slate-900">
          Connecting your {provider === "outlook" ? "Outlook" : "Gmail"} account…
        </div>
        <div className="mt-2 text-sm text-slate-500">One moment — completing the secure handshake.</div>
      </div>
    </div>
  );
}
